<template>
	<div class="full" style="box-sizing: border-box;padding: 10px;">
		<vxe-grid :ref="moduleName+'_list'" v-bind="gridOptions" @toolbar-button-click="toolbarButtonClickEvent"
			:loading="loading"></vxe-grid>
	</div>
</template>
<script>
	import listBase from '@_system/components/base/list.vue'
	export default {
		extends: listBase,
		props: {
			foreingKey: {
				type: Object,
				default: () => {
					return {
						mode: 'detail'
					}
				}
			}
		},
		data() {
			return {
				loading: false,
				moduleName: 'invoicecustomer',
				gridOptions: null,
				columns: [{
					field: '',
					title: '',
					type: 'checkbox',
					fixed: 'left'
				}, {
					field: 'update_time',
					title: '最近抓取时间',
					render: '$datePicker',
					formatter: "datetime",
					fixed: 'right',
					width: 150
				}, {
					field: 'tp_buyer',
					title: '买家ID',
					render: '$input',
					width: 100
				}, {
					field: 'showName',
					title: '店铺名称',
					render: '',
					width: 100
				}, {
					field: 'status',
					title: '开票状态',
					render: '$select',
					props: {
						selectoptions: [{
								"value": 0,
								"label": "未开票",
							},
							{
								"value": 1,
								"label": "待开票",
							},
							{
								"value": 2,
								"label": "开票中",
							},
							{
								"value": 3,
								"label": "已开票",
							},
							{
								"value": 4,
								"label": "开票失败",
							}
						],
						"multiple": true
					},
					name: '',
					width: 100
				}, {
					field: 'payeeName',
					title: '开票公司',
					render: '$input',
					width: 100
				}, {
					field: 'salercpt_no',
					title: '万里牛单号',
					render: '$input',
					width: 100
				}, {
					field: 'tp_tid',
					title: '线上单号',
					render: '$input',
					width: 100
				}, {
					field: 'title',
					title: '抬头',
					render: '$input',
					width: 100
				}, {
					field: 'taxID',
					title: '税号',
					render: '$input',
					width: 100
				}, {
					field: 'email',
					title: '邮箱',
					render: '$input',
					width: 100
				}, {
					field: 'error',
					title: '错误',
					render: '',
					fixed: 'right',
					width: 100
				}],
				toolbarButton: [{
					name: '开票',
					code: 'invoice',
					status: 'success'
				}],
				operateInrowButton: [],
				operateButtonConfig: ['invoice', 'invoicepdf'],
				operateButtonList: []
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			initList() {
				this.operateButtonList = [{
					code: 'invoice',
					content: '开票',
					status: 'success',
					icon: 'vxe-icon-envelope',
					inrow: true,
				}, {
					code: 'invoicepdf',
					content: '文件',
					status: '',
					icon: 'vxe-icon-file-pdf',
					inrow: true,
				}]
				this.initOperateButton()
				this.initOption()
				console.log(this.operateInrowButton)
			},
			toolbarButtonClickEvent(e) {
				if (e.code == 'setcookie') {
					alert('抓取开发中')
				}
				if (e.code == 'invoice') {
					let data = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
					if (data.length != 0) {
						let postdata = []
						data.forEach((item) => {
							if (item.status == '未开票') {
								postdata.push(item.id)
							}
						})
						this.electronicInvoice(postdata)
					}
				}
			},
			operateButtonClickEvent(e) {
				if (e.code == 'invoice') {
					if (e.data.status === '未开票' || e.data.status === '待开票') {
						this.$confirm('是否确认开票 ', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.electronicInvoice([e.data.id])
						}).catch(() => {

						})

					} else {
						this.$message.error('状态不为未开票或待开票')
					}
				}
				if (e.code == 'invoicepdf') {
					if(e.data.invoiceurl){
						window.open(e.data.invoiceurl)
					}else{
						this.$message.error('文件未下载')
					}
				}
				console.log(e)
			},
			electronicInvoice(ids) {
				this.loading = true
				this.$api[this.moduleName].electronicInvoice({
					ids: ids
				}).then(() => {
					this.loading = false
					this.customreload()
				}, () => {
					this.loading = false
				})
			},

		},
		components: {

		}
	}
</script>
